import React from 'react'
import LayoutContainer from './shared/LayoutContainer'
import Text from './shared/Text'

const Aktuelles = () => {
	return (
		<LayoutContainer>
            <h2>Aktuelles</h2>

			<h4>Bibelschule mit Thierry Kopp ...</h4>
			<Text>
				Nach längerer Pause geht es bald weiter ... <br/>
				Am Samstag (28.11.) um 10 Uhr. <br/>
				Infos hier: (<a href="https://mtolives.info/events/2026-11-28/"> Prophetisches Bibelschulseminar</a> sein. )<br/>
			</Text>

			<h3>Regelmäßige Termine bei Mt. Olives Prayer & Worship ...</h3>
			<Text>
				Unsere regelmäßigen Termine:<br/>
				Die Bibel: Gottes Geheimnisse entdecken - montags um 19:30 Uhr. <br/>
				Lobpreis und Gebet - dienstags um 19:30 Uhr. <br/>
				Lobpreis und Gebet - donnerstags um 9:00 Uhr. <br/>
				Näheres siehe ganz unten auf unserer Terminseite <br/>
				Auch hierzu sind neue Gäste herzlich willkommen.
			</Text>
			<hr/>

		</LayoutContainer>
	)
}

export default Aktuelles



// WEBPACK FOOTER //
// ./src/components/Aktuelles.js